import {
  GetRequest,
  DeleteRequest,
  PostRequestJson,
  PutRequestJson,
} from "src/shared/api";
import { config } from "src/config/config";
import { isBlank } from "src/utils/validate_util";
import { AssetBusinessCond, MvpApiVersion } from "./api_types";

export const getAssetsCreatedByUserAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.created_assets}`;
  const data: Record<string, any> = {
    offset: Number(options.pageNumber) * Number(options.pageSize),
    limit: options.pageSize,
    sort_by: options.sortBy,
  };
  if (!isBlank(options.assetType)) {
    data.asset_type = options.assetType;
  }
  if (!isBlank(options.mediaType)) {
    data.media_type = options.mediaType;
  }
  if (!isBlank(options.bizCond)) {
    data.listing_type = options.bizCond;
  }
  return GetRequest(url, data, {});
};

export const getKidAssetsCreatedByUserAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.created_kid_assets(options.kid)}`;
  return GetRequest(url, null, {});
};

export const getSerialsCreatedByUserAPI = (options: any) => {
  let url: string = "";
  url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.created_kid_assets_per_serial(
    options.kid
  )}`;

  return GetRequest(url, null, {});
};

export const getKidAssetsCollectedByUserAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.owned_kid_assets(options.kid)}`;
  return GetRequest(url, null, {});
};

export const getSerialsCollectedByUserAPI = (options: any) => {
  let url: string = "";
  url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.owned_kid_assets_per_serial(options.kid)}`;

  const data: Record<string, any> = {
    asset_token_ids: options.assetTokenIds,
  };

  return PostRequestJson(url, data, {});
};

export const getTradeListingSerialsAPI = (options: any) => {
  let url: string = "";
  url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.trade_listing_serial(options.kid)}`;

  const data: Record<string, any> = {
    asset_token_ids: options.assetTokenIds,
  };

  return GetRequest(url, data, {});
};

export const getKidAssetsRentedByUserAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.rented_kid_assets(options.kid)}`;
  return GetRequest(url, null, {});
};

export const updateAssetAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.update_asset}`;
  const data: Record<string, any> = {
    asset_token_id: options.assetTokenID,
    title: options.title,
    description: options.description,
    brand_id: options.brand_id,
    group_key: options.group_key,
    asset_type: options.assetType,
    batch: options.batch,
    creator_royalty_rate: options.creatorRoyaltyRate,
    rental_creator_royalty_rate: options.rentalCreatorRoyaltyRate,
    sale_starting_at: options.saleStartingAt,
    sale_ending_at: options.saleEndingAt,
    secondary_sale_enabled: options.secondarySaleEnabled,
    trade_enabled: options.tradeEnabled,
    secondary_rental_enabled: options.secondaryRentalEnabled,
    only_japan_accessible: options.onlyJapanAccessible,
    min_sellable_price: options.minSellablePrice,
    download_enabled: options.downloadEnabled,
  };
  return PutRequestJson(url, data, {});
};

export const delistAssetAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.delist_asset}`;
  const data: Record<string, any> = {
    assets: options.assets,
    batch: options.batch,
  };

  return PostRequestJson(url, data, {});
};

export const copyAssetAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.copy_asset}`;
  const data: Record<string, any> = {
    title: options.title,
    description: options.description,
    kid: options.kid,
    copies_count: options.copies_count,
    asset_type: options.asset_type,
  };

  return PostRequestJson(url, data, {});
};

export const listAssetAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.list_asset}`;
  const data = {
    asset_token_ids: options.assetTokenIDs,
    sale_price: options.salePrice,
    rent_price: options.rentPrice,
    rental_period_seconds: options.rentalPeriod,
    batch: options.batch,
  };

  return PostRequestJson(url, data, {});
};

export const offerTradingAssetAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.offer_trading_asset}`;
  const data: Record<string, any> = {
    submitted_asset_token_ids: options.submittedAssetTokenIDs,
    requested_asset_token_ids: options.requestedAssetTokenIDs,
    wait_offers: options.waitOffers,
  };

  return PostRequestJson(url, data, {});
};

export const calcFreeDistributionFeeAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.calc_free_distribution_fee}`;
  const data: Record<string, any> = {
    asset_token_ids: options.assetTokenIDs,
  };
  return PostRequestJson(url, data, {});
};

export const distributeAssetAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.distribute_asset}`;
  const allowed_asset_acquirers = options.acquirers.map((email) => {
    return { email: email };
  });
  const data: Record<string, any> = {
    asset_token_ids: options.assetTokenIDs,
    asset_acquirer_restriction: {
      allowed_asset_acquirers: allowed_asset_acquirers,
    },
    asset_acquisition_count_restriction: {
      max_count_per_wallet: options.limitOnNumber,
    },
    lang: options.lang,
  };
  return PostRequestJson(url, data, {});
};

export const createFreeRentalSettingAPI = (options: any) => {
  const url = `${config.MARKETPLACE_API.HOST}${config.MARKETPLACE_API.APIS_V2.free_rental_setting}`;
  const allowed_asset_renters = options.renters.map((email) => {
    return { email: email };
  });
  const data: Record<string, any> = {
    asset_token_ids: options.assetTokenIDs,
    rental_period_seconds: options.rentalPeriodSeconds,
    asset_renter_restriction: {
      allowed_asset_renters: allowed_asset_renters,
    },
  };
  return PostRequestJson(url, data, {});
};

export const getFlowTransactionStatusAPI = (options: any) => {
  const url = `${
    config.MARKETPLACE_API.HOST
  }${config.MARKETPLACE_API.APIS_V2.flow_tx_status(options.transactionId)}`;

  return GetRequest(url, null, {});
};
